import { Shimmer } from '@components/Shimmer'
import { View, XStack, YStack } from 'tamagui'

export function CourseContentConsumptionGhostLoading() {
  return (
    <YStack
      flex={1}
      testID="course-content-consumption-ghost-loading"
      backgroundColor="$bg-chrome"
    >
      <YStack flex={1} marginTop={100}>
        <View paddingHorizontal={'$spacing-inset-xs'}>
          <View
            backgroundColor="$skeleton-base"
            height={200}
            justifyContent="center"
            alignItems="center"
            borderRadius={8}
            $gtSm={{ height: 400 }}
          />
        </View>

        <YStack flex={1} paddingTop="$spacing-inset-sm">
          <YStack
            gap="$spacing-inset-quarck"
            paddingHorizontal="$spacing-inset-sm"
          >
            <Shimmer width="80%" height={32} $gtSm={{ width: '60%' }} />

            <XStack
              alignItems="center"
              justifyContent="space-between"
              paddingVertical="$spacing-inset-xxs"
              marginTop="$spacing-inset-xxs"
            >
              <YStack gap="$spacing-quarck" alignItems="center">
                <Shimmer width={21} height={21} borderRadius={100} />
                <Shimmer width={80} height={24} />
              </YStack>

              <XStack gap="$spacing-inset-quarck">
                <Shimmer width={40} height={40} borderRadius={100} />
                <Shimmer width={40} height={40} borderRadius={100} />
              </XStack>
            </XStack>
          </YStack>

          <YStack marginTop="$spacing-inset-xs" flex={1}>
            <XStack
              paddingHorizontal="$spacing-inset-sm"
              gap="$spacing-inset-quarck"
            >
              <Shimmer width={100} height={32} borderRadius={8} />
              <Shimmer width={100} height={32} borderRadius={8} />
              <Shimmer width={100} height={32} borderRadius={8} />
            </XStack>

            <YStack
              marginTop="$spacing-inset-sm"
              paddingHorizontal="$spacing-inset-sm"
              gap="$spacing-inset-xs"
            >
              <Shimmer width="100%" height={80} borderRadius={8} />
              <Shimmer width="100%" height={80} borderRadius={8} />
              <Shimmer width="100%" height={80} borderRadius={8} />
            </YStack>
          </YStack>
        </YStack>
      </YStack>
    </YStack>
  )
}
